<template>
    <div class="access_parking_records">
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete(dataAccessNoCode.nombre, dataAccessNoCode.host, dataAccessNoCode.f_acceso, dataAccessNoCode.company_logo)"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Mensaje   -->
        <v-dialog v-model="bandConfirm"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title class="warning display-1 text--primary justify-center"
                      primary-title>
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <div class="text-xs-center">
                      {{$t('at_least_one_data')}}
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="bandConfirm = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTransport" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{bandTransportUpdate === true? $t('add_carrier_data') : $t('carrier_data')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                      <v-radio-group
                          row
                          :disabled="!bandTransportUpdate"
                          v-model="typeService"
                          prepend-icon="trolley"
                          name="typeService"
                          :mandatory="false"
                          :error-messages="errores.typeService"
                      >
                        <v-radio :label="$t('load')" :value="true"></v-radio>
                        <v-radio :label="$t('download')" :value="false"></v-radio>
                      </v-radio-group>
                      <v-text-field
                          v-model="case_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="inventory"
                          name="case_plates"
                          :label="$t('case_plates')"
                          :error-messages="errores.case_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="container_platform_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="local_shipping"
                          name="container_platform_plates"
                          :label="$t('container_platform_plates')"
                          :error-messages="errores.container_platform_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="transport_line"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="rv_hookup"
                          name="transport_line"
                          :label="$t('transport_line')"
                          :error-messages="errores.transport_line"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="supplier_customer_name"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="business"
                          name="supplier_customer_name"
                          :label="$t('supplier_customer_name')"
                          :error-messages="errores.supplier_customer_name"
                      >
                      </v-text-field>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogTransport = false"
                      >{{ $t('cancelar') }}
                      </v-btn>
                    <v-spacer/>
                    <v-btn
                        v-show="bandTransportUpdate === true"
                        color="primary"
                        @click="addAccessCarrierData"
                        :loading="loading"
                    >{{$t('guardar')}}
                    </v-btn>
                    <v-btn
                        v-show="bandTransportUpdate === false"
                        color="primary"
                        @click="dialogTransport = false"
                    >{{$t('aceptar')}}
                    </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-dialog v-model="dialogShowPlacas" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{$t('placas')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                    <v-img
                        :src="imagenPlacas"
                        position="center center"
                        class="grey lighten-2"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogShowPlacas = false, imagenPlacas = ''"
                      >{{ $t('cerrar') }}
                      </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCav" scrollable max-width="1000px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>CAV del embarque</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon :loading="loadingCav" @click="refreshCavData" :disabled="!selectedShippingWindowId">
                        <v-icon>refresh</v-icon>
                    </v-btn>
                    <v-btn icon @click="closeCavModal">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 class="pa-2">
                            <v-card outlined>
                                <v-card-title class="subtitle-1 font-weight-bold">
                                    Resumen CAV editable
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text v-if="loadingCav" class="text-xs-center py-4">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-card-text>
                                <v-card-text v-else-if="cavData">
                                    <v-alert
                                        v-if="!canEditCav"
                                        :value="true"
                                        type="info"
                                        outlined
                                        class="mb-3"
                                    >
                                        Tu perfil puede consultar y descargar CAV, pero no editarlo. Solo administrador o supervisor de embarques pueden actualizar CAV.
                                    </v-alert>

                                    <v-layout row wrap>
                                        <v-flex
                                            v-for="fieldKey in cavUiFieldOrder"
                                            :key="fieldKey"
                                            xs12
                                            sm6
                                            class="pa-1"
                                        >
                                            <v-switch
                                                v-if="isCavBooleanField(fieldKey)"
                                                v-model="cavForm[fieldKey]"
                                                :label="getCavFieldLabel(fieldKey)"
                                                :disabled="!canEditCav || loadingCavSave"
                                                @change="markCavFieldEdited(fieldKey, cavForm[fieldKey])"
                                            ></v-switch>

                                            <v-textarea
                                                v-else-if="isCavTextareaField(fieldKey)"
                                                v-model="cavForm[fieldKey]"
                                                :label="getCavFieldLabel(fieldKey)"
                                                outlined
                                                rows="3"
                                                :disabled="!canEditCav || loadingCavSave"
                                                @input="markCavFieldEdited(fieldKey, cavForm[fieldKey])"
                                            ></v-textarea>

                                            <v-text-field
                                                v-else
                                                v-model="cavForm[fieldKey]"
                                                :label="getCavFieldLabel(fieldKey)"
                                                :type="getCavInputType(fieldKey)"
                                                :hint="getCavFieldHint(fieldKey)"
                                                :persistent-hint="Boolean(getCavFieldHint(fieldKey))"
                                                outlined
                                                dense
                                                :disabled="!canEditCav || loadingCavSave"
                                                @input="markCavFieldEdited(fieldKey, cavForm[fieldKey])"
                                            ></v-text-field>

                                            <div v-if="canEditCav && !isCavBooleanField(fieldKey)" class="text-xs-right mt-1">
                                                <v-btn
                                                    x-small
                                                    flat
                                                    color="warning"
                                                    class="mr-1"
                                                    :disabled="loadingCavSave"
                                                    @click="clearCavField(fieldKey)"
                                                >
                                                    Limpiar
                                                </v-btn>
                                                <v-btn
                                                    x-small
                                                    flat
                                                    color="primary"
                                                    :disabled="loadingCavSave"
                                                    @click="restoreCavField(fieldKey)"
                                                >
                                                    Restaurar
                                                </v-btn>
                                            </div>
                                        </v-flex>
                                    </v-layout>

                                    <div class="text-xs-right mt-3" v-if="canEditCav">
                                        <v-btn
                                            class="mr-2"
                                            color="default"
                                            :disabled="loadingCavSave"
                                            @click="resetCavForm"
                                        >
                                            Revertir cambios
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            :loading="loadingCavSave"
                                            @click="submitCavEdit"
                                        >
                                            Guardar cambios CAV
                                        </v-btn>
                                    </div>
                                </v-card-text>
                                <v-card-text v-else class="grey--text">
                                    No fue posible cargar los datos CAV para este embarque.
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="info"
                        :loading="loadingCavPdf"
                        :disabled="!selectedShippingWindowId"
                        @click="downloadCavPdfByShippingWindowId(selectedShippingWindowId)"
                    >
                        <v-icon left>picture_as_pdf</v-icon>
                        Descargar PDF CAV
                    </v-btn>
                    <v-btn color="primary" @click="closeCavModal">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal para ver 17 puntos de seguridad -->
        <v-dialog v-model="dialog17Points" scrollable max-width="1000px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Revisión de 17 Puntos de Seguridad</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon :loading="loading17Points" @click="refresh17PointsData" :disabled="!selected17PointsShippingWindowId">
                        <v-icon>refresh</v-icon>
                    </v-btn>
                    <v-btn icon @click="close17PointsModal">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text v-if="loading17Points" class="text-center py-6">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    <p class="mt-2 grey--text">Cargando datos de revisión...</p>
                </v-card-text>

                <v-card-text v-else-if="data17Points">
                    <!-- Encabezado de información -->
                    <v-card class="mb-4" outlined>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Folio:</strong> {{ data17Points.folio }}</div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Tipo:</strong> {{ data17Points.tipo_revision_display }}</div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Fecha:</strong> {{ data17Points.fecha }}</div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Operador:</strong> {{ data17Points.operador_nombre }} ({{ data17Points.operador_numero_empleado }})</div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Vehículo:</strong> {{ data17Points.vehiculo_placas_unidad }}</div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="pa-2">
                                    <div><strong>Transportista:</strong> {{ data17Points.empresa_transportista_nombre }}</div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>

                    <!-- Tabla de puntos de inspección -->
                    <div class="elevation-1">
                        <table class="inspection-table">
                            <thead>
                                <tr class="table-header">
                                    <th class="table-header-cell">No.</th>
                                    <th class="table-header-cell">Punto de Inspección</th>
                                    <th class="table-header-cell">Estado</th>
                                    <th class="table-header-cell">Observaciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(respuesta, idx) in data17Points.respuestas_inspeccion" :key="idx" :class="respuesta.cumple === 'no' ? 'row-error' : (respuesta.cumple === 'na' ? 'row-warning' : '')">
                                    <td class="table-cell text-center font-weight-bold">{{ respuesta.punto.numero }}</td>
                                    <td class="table-cell">{{ respuesta.punto.descripcion }}</td>
                                    <td class="table-cell text-center">
                                        <v-chip :color="getStatusColor(respuesta.cumple)" text-color="white" small>
                                            {{ respuesta.cumple_display }}
                                        </v-chip>
                                    </td>
                                    <td class="table-cell">{{ respuesta.observaciones || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Resumen de resultados -->
                    <v-layout row wrap class="mt-4">
                        <v-flex xs12 sm6 md4>
                            <v-card class="text-center pa-4" outlined>
                                <div class="text-xs-center">
                                    <v-icon large color="success" class="mb-2">check_circle</v-icon>
                                    <div class="font-weight-bold">{{ get17PointsSummary.si }}</div>
                                    <small class="grey--text">Conformes</small>
                                </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-card class="text-center pa-4" outlined>
                                <div class="text-xs-center">
                                    <v-icon large color="error" class="mb-2">cancel</v-icon>
                                    <div class="font-weight-bold">{{ get17PointsSummary.no }}</div>
                                    <small class="grey--text">No Conformes</small>
                                </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-card class="text-center pa-4" outlined>
                                <div class="text-xs-center">
                                    <v-icon large color="warning" class="mb-2">help</v-icon>
                                    <div class="font-weight-bold">{{ get17PointsSummary.na }}</div>
                                    <small class="grey--text">No Aplica</small>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-text v-else class="text-center grey--text py-6">
                    No se encontraron datos de revisión de seguridad para este embarque.
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close17PointsModal">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container class="my-1">
            <v-layout calign-center>
                <v-dialog scrollable v-model="dialog_accesos_no_code_express" max-width="600">
                    <v-card color="blue-grey lighten-4"  class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Detalles</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_no_code_express = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center">
                                                <v-img
                                                        :src="data_accesos_no_code_express.url_foto"
                                                        position="center center"
                                                        class="grey lighten-2"
                                                ></v-img>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ (data_accesos_no_code_express.notas === '' || data_accesos_no_code_express.notas === null) ? "Sin Notas" : data_accesos_no_code_express.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_salida ? data_accesos_no_code_express.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog scrollable persistent v-model="dialog_accesos_without_code" max-width="1000">
                    <v-card :loading="loadingCountInAccessNoCode" v-if="entrada" :color="dataAccessNoCode.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                          </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.authorized" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.authorized"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> autorizar acceso
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                                  large
                                  color="primary"
                              >
                                Disponible en : {{countDownAuthorizedAccessNoCode}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                    <v-card :loading="loadingCountInAccessNoCode" v-if="salida" :color="dataAccessNoCode.pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.pase_salida" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_pase_salida}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.pase_salida"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_firmar(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> firmar pase de salida
                              </v-btn>
                              <v-btn
                                      v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign > 0"
                                      large
                                      color="primary"
                              >
                                  Disponible en : {{countDownSign}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-card-text>
                            <h3>{{$t('mostrando_historial_dia')}}</h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout class="align-center " row wrap>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedFinalDateFormatted"
                                                        prepend-icon="event"
                                                        name="date2"
                                                        :label="$t('Fecha_fin')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date2"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date2"
                                                    @input="calendario2 = false, submit()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                                large
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-card class="my-2" v-show="getProfile.enable_shipments">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_history_shipments')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        small
                        @click="exportPdfParking()"
                        :disabled="dataAccessParking.length === 0"
                        title="Descargar PDF"
                    >
                        <v-icon>picture_as_pdf</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        small
                        @click="exportExcelParking()"
                        :disabled="dataAccessParking.length === 0"
                        title="Descargar Excel"
                    >
                        <v-icon>table_chart</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                        <v-flex >
                            <v-card-title>
                              <v-text-field
                                  v-model="searchDataParking"
                                  append-icon="search"
                                  :label="$t('Buscar')"
                                  single-line
                                  hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headersParkingAccess"
                                    :loading="loading_data_parking"
                                    :items="dataAccessParking"
                                    :search="searchDataParking"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '10', value: 10},
                                        {text: '20', value: 20},
                                        {text: '50', value: 50},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_accesos')"
                            >
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" class="white--text" icon="warning">
                                        {{$t('ningun_resultado_1')}} "{{ searchDataParking }}" {{$t('ningun_resultado_2')}}
                                    </v-alert>
                                </template>
                                <template v-slot:items="props">
                                    <td class="text-xs-center">
                                        <v-btn
                                            v-if="getProfile.is_cav_active"
                                            icon
                                            small
                                            color="primary"
                                            :disabled="!canViewCav || !resolveShippingWindowId(props.item)"
                                            @click="openCavModal(props.item)"
                                            title="Ver CAV"
                                        >
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="getProfile.is_cav_active"
                                            icon
                                            small
                                            color="info"
                                            :loading="loadingCavPdf && selectedShippingWindowId === resolveShippingWindowId(props.item)"
                                            :disabled="!canViewCav || !resolveShippingWindowId(props.item)"
                                            @click="downloadCavPdfByShippingWindowId(resolveShippingWindowId(props.item))"
                                            title="Descargar PDF CAV"
                                        >
                                            <v-icon small>picture_as_pdf</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="getProfile.is_17_points_enabled"
                                            icon
                                            small
                                            color="success"
                                            :loading="loading17Points && selected17PointsShippingWindowId === resolveShippingWindowId(props.item)"
                                            :disabled="!resolveShippingWindowId(props.item) || canViewSecurityRevision === false"
                                            @click="open17PointsModal(props.item)"
                                            title="Ver 17 Puntos de Seguridad"
                                        >
                                            <v-icon small>security</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>{{ props.item.window_date }}</td>
                                    <td>
                                        <div v-if="props.item.clients_count && props.item.clients_count > 1">
                                            <v-chip small color="primary" text-color="white">{{ props.item.clients_count }} destinos</v-chip>
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn text small color="primary" v-on="on">Ver todos</v-btn>
                                                </template>
                                                <v-card class="pa-3" max-width="300px">
                                                    <div v-for="(client, idx) in props.item.clients_detail" :key="idx" class="mb-2 text-truncate">
                                                        <strong>{{ client.name || client.code }}</strong>
                                                    </div>
                                                </v-card>
                                            </v-menu>
                                        </div>
                                        <span v-else>{{ props.item.client_name }}</span>
                                    </td>
                                    <td>{{ props.item.window_time }}</td>
                                    <td>{{ props.item.guest_name }}</td>
                                    <td>{{ props.item.loading_area }}</td>
                                    <td><v-alert :value="true" :type="props.item.access_type === 'ENTRY' ? 'info' : 'success'">{{ props.item.access_type === 'ENTRY' ? $t('adentro') : $t('completado') }}</v-alert></td>
                                    <td>{{ props.item.access_time_formatted === null ? $t('pendiente')  : props.item.access_time_formatted }}</td>
                                    <td>{{ props.item.loading_start_time_formatted === null ? $t('pendiente')  : props.item.loading_start_time_formatted }}</td>
                                    <td>{{ props.item.loading_end_time_formatted === null ? $t('pendiente')  : props.item.loading_end_time_formatted }}</td>
                                    <td>{{ props.item.exit_time_formatted === null ? $t('pendiente')  : props.item.exit_time_formatted }}</td>
                                    <td>{{ props.item.registered_by_name}}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import {mapState} from 'vuex'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'
    import { mapGetters } from 'vuex'
    import XLSX from 'xlsx'

    export default {
        name: "access_parking_records",
        data: () => ({
            alerta: false,
            calendario: false,
            calendario2: false,
            fecha_actual: '',
            date: '',
            date2: '',
            errores: [],
            search: '',
            searchDataParking: '',
            headers4: [],
            headers5: [],
            invitaciones:[],
            accesos_without_code: [],
            accesos_no_code_express: [],
            loading_data_invitaciones: false,
            loading_data_accesos_without_code: false,
            loading_data_accesos_no_code_express: false,
            loading_data_parking: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            dialog_accesos_without_code: false,
            dialog_accesos_no_code_express: false,
            headersAccess: [],
            loading_data_accesos: false,
            accesos: [],
            headersAccessExcel: [],
            headersAccessNoCodeExcel: [],
            headersAccessNoCodeExpressExcel: [],
            data_accesos_without_code: [],
            data_accesos_no_code_express: [],
            band: false,
            search3: '',
            img: '',
            camera: null,
            deviceId: null,
            devices: [],
            dialogPlacas: false,
            loading: false,
            idAccess: '',
            idAccessNoCode: '',
            dialogShowPlacas: false,
            imagenPlacas: '',
            countDownAuthorized: 0,
            countDownPass: 0,
            dialog_errores: false,
            errores_guard: '',
            head_color: '',
            band_gafete: false,
            loading_gafete: false,
            salida: false,
            entrada: false,
            loadingCountInAccessNoCode: false,
            dataAccessNoCode: {},
            countDownAuthorizedAccessNoCode: 0,
            dialog_inicio: false,
            casetas: [],
            access: [],
            loading_data_access2: false,
            headersAccess2: [],
            headersParkingAccess: [],
            countDownSign: 0,
            caseta: 0,
            typeService: null,
            case_plates: '',
            container_platform_plates: '',
            transport_line: '',
            supplier_customer_name: '',
            bandTransportUpdate: false,
            bandConfirm: false,
            dialogTransport: false,
            accessQRCode: false,
            accessContractor: false,
            dataAccessParking: [],
            id_empresa: '',
            dialogCav: false,
            loadingCav: false,
            loadingCavSave: false,
            loadingCavPdf: false,
            selectedShippingWindowId: null,
            cavData: null,
            cavForm: {},
            cavOriginal: {},
            cavDirtyFields: {},
            cavNullFields: {},
            dialog17Points: false,
            loading17Points: false,
            selected17PointsShippingWindowId: null,
            data17Points: null,
            cavUiFieldOrder: [
                'folio',
                'is_final',
                'empresa_name',
                'transport_company_name',
                'client_name',
                'destination_client_name',
                'loading_area',
                'window_date',
                'window_time',
                'entry_time',
                'exit_time',
                'vehicle_plate',
                'vehicle_type',
                'vehicle_economic_number',
                'driver_name',
                'weight_in_kg',
                'weight_out_kg',
                'weight_net_kg',
                'scale_number_in',
                'scale_number_out',
                'guard_in_name',
                'guard_out_name',
                'guard_notes_in',
                'guard_notes_out',
                'supervisor_name',
                'double_verification_number'
            ],
            cavEditableKeys: [
                'folio',
                'is_final',
                'empresa_logo_b64',
                'empresa_logo_mime',
                'empresa_name',
                'transport_company_name',
                'client_name',
                'destination_client_name',
                'loading_area',
                'window_date',
                'window_time',
                'entry_time',
                'exit_time',
                'vehicle_plate',
                'vehicle_type',
                'vehicle_economic_number',
                'driver_name',
                'weight_in_kg',
                'weight_out_kg',
                'weight_net_kg',
                'scale_number_in',
                'scale_number_out',
                'guard_in_name',
                'guard_out_name',
                'guard_notes_in',
                'guard_notes_out',
                'supervisor_name',
                'double_verification_number'
            ],
        }),
        created: function(){
            this.get_extra_data()
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.date2 = this.fecha_actual
            // this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
        },
        beforeUpdate() {
            this.headersParkingAccess = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'cav_actions'
                },
                {
                    text: 'Fecha Invitación',
                    align: 'left',
                    sortable: true,
                    value: 'window_date'
                },
                {
                    text: 'Destino',
                    align: 'left',
                    sortable: true,
                    value: 'client_name'
                },
                {
                    text: 'Hora Invitación',
                    align: 'left',
                    sortable: true,
                    value: 'window_time'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_name'
                },
                {
                    text: this.$t('loading_area'),
                    align: 'left',
                    sortable: true,
                    value: 'loading_area'
                },
                {
                    text: this.$t('estado'),
                    align: 'left',
                    sortable: true,
                    value: 'access_type'
                },
                {
                    text: 'Llegada',
                    align: 'left',
                    sortable: true,
                    value: 'access_time_formatted'
                },
                {
                    text: 'Entrada a Carga',
                    align: 'left',
                    sortable: true,
                    value: 'loading_start_time_formatted'
                },
                {
                    text: 'Salida de Carga',
                    align: 'left',
                    sortable: true,
                    value: 'loading_end_time_formatted'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_time_formatted'
                },
                {
                    text: this.$t('Vigilante'),
                    align: 'left',
                    sortable: true,
                    value: 'registered_by_name'
                },
            ]
            this.headersAccess2 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('type_of_access'),
                    align: 'left',
                    sortable: true,
                    value: 'access_qr_code'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkout'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ],
            this.headersAccess = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'invitado'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('temperature'),
                    align: 'left',
                    sortable: true,
                    value: 'temperature'
                },
                {
                    text: this.$t('estado'),
                    align: 'left',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'id_invitacion'
                }
            ],
            this.headersAccessExcel = [
                {
                    label: this.$t('type_of_access'),
                    field: 'access_qr_code',
                    dataFormat: this.typeAccessFormat
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest_full_name'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'company_name',
                },
                {
                    label: this.$t('estado'),
                    field: 'status',
                    dataFormat: this.estadoFormat
                },
                {
                    label: this.$t('hora_llegada'),
                    field: 'datetime_arrival'
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'datetime_checkin'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'datetime_checkout'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'host_full_name'
                }
            ],
            this.headers4 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'acciones'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'nombree'
                }
            ],
            this.headers5 = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                }
            ],
            this.headersAccessNoCodeExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'empresa',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'hostFirstName'
                }
            ]
            this.headersAccessNoCodeExpressExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Area'),
                    field: 'areaName',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Notas'),
                    field: 'notas'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            },
            canViewCav () {
                const profile = this.getProfile || {}
                return profile.roll === 5 || profile.roll === 1
            },
            canEditCav () {
                const profile = this.getProfile || {}
                const isAdmin = profile.roll === 5
                const isShipmentsSupervisor = profile.roll === 1 && profile.is_supervisor === true
                return isAdmin || isShipmentsSupervisor
            },
            canViewSecurityRevision () {
                const profile = this.getProfile || {}
                const roll = profile.roll
                // Admin (5), Supervisor (1), Analista (3)
                return roll === 5 || roll === 1 || roll === 3
            },
            get17PointsSummary () {
                if (!this.data17Points || !this.data17Points.respuestas_inspeccion) {
                    return { si: 0, no: 0, na: 0 }
                }
                const summary = {
                    si: 0,
                    no: 0,
                    na: 0
                }
                this.data17Points.respuestas_inspeccion.forEach(item => {
                    if (item.cumple === 'si') summary.si++
                    else if (item.cumple === 'no') summary.no++
                    else if (item.cumple === 'na') summary.na++
                })
                return summary
            },
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        watch: {
            camera: function(id) {
                this.deviceId = id
            },
            devices () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices
                if (first) {
                    this.camera = first.deviceId
                    this.deviceId = first.deviceId
                }else {
                    this.camera = tail.deviceId
                    this.deviceId = tail.deviceId
                }
            }
        },
        methods:{
            get_extra_data (){
                this.loading_data_parking = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_access_parking_by_date () {
                this.loading_data_parking = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/guard/access-logs/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        start_date: this.yyyy + '-' + this.mm + '-' + this.dd,
                        end_date: this.yyyy2 + '-' + this.mm2 + '-' + this.dd2,
                        empresa_id: this.id_empresa,
                        limit: 10000
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading_data_parking = false
                        console.log('Total registros cargados:', response.data.length)
                        this.dataAccessParking = response.data
                    })
                    .catch(error => {
                        this.loading_data_parking = false
                        console.log(error)
                    })
            },
            resolveShippingWindowId (item) {
                if (!item) return null
                return item.shipping_window_id || item.window_id || item.shipment_window_id || item.shippingWindowId || null
            },
            openCavModal (item) {
                if (!this.canViewCav) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Tu perfil no tiene permiso para consultar CAV.')
                    return
                }

                const shippingWindowId = this.resolveShippingWindowId(item)
                if (!shippingWindowId) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Este registro no incluye shipping_window_id para consultar CAV.')
                    return
                }

                this.selectedShippingWindowId = shippingWindowId
                this.dialogCav = true
                this.resetCavForm()
                this.refreshCavData()
            },
            closeCavModal () {
                this.dialogCav = false
                this.selectedShippingWindowId = null
                this.cavData = null
                this.resetCavForm()
            },
            refreshCavData () {
                if (!this.selectedShippingWindowId) return
                this.fetchCavSummary(this.selectedShippingWindowId)
            },
            fetchCavSummary (shippingWindowId) {
                this.loadingCav = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/scale/cav/' + shippingWindowId + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }

                axios(config)
                    .then(response => {
                        this.cavData = response.data
                        this.initializeCavForm(response.data)
                        this.loadingCav = false
                    })
                    .catch(error => {
                        this.loadingCav = false
                        this.cavData = null
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', (error.response && error.response.data && (error.response.data.error || error.response.data.detail)) || 'No se pudo consultar el CAV.')
                    })
            },
            submitCavEdit () {
                if (!this.canEditCav) return

                if (!this.selectedShippingWindowId) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'No se encontro shipping_window_id para actualizar CAV.')
                    return
                }

                const parsedBody = this.buildCavPatchPayload()

                const payloadKeys = Object.keys(parsedBody)
                if (!payloadKeys.length) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Incluye al menos un campo para actualizar el CAV.')
                    return
                }

                const invalidKeys = payloadKeys.filter(key => !this.cavEditableKeys.includes(key))
                if (invalidKeys.length) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Campos no permitidos en CAV: ' + invalidKeys.join(', '))
                    return
                }

                if (Object.prototype.hasOwnProperty.call(parsedBody, 'is_final') && parsedBody.is_final !== null && typeof parsedBody.is_final !== 'boolean') {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'El campo is_final debe ser booleano (true o false) o null.')
                    return
                }

                if (Object.prototype.hasOwnProperty.call(parsedBody, 'window_date') && parsedBody.window_date !== null) {
                    const validDate = /^\d{4}-\d{2}-\d{2}$/.test(String(parsedBody.window_date))
                    if (!validDate) {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'warning')
                        this.$store.commit('snackbar_change_message', 'window_date debe tener formato YYYY-MM-DD.')
                        return
                    }
                }

                if (Object.prototype.hasOwnProperty.call(parsedBody, 'window_time') && parsedBody.window_time !== null) {
                    const timeValue = String(parsedBody.window_time)
                    if (!/^\d{2}:\d{2}(:\d{2})?$/.test(timeValue)) {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'warning')
                        this.$store.commit('snackbar_change_message', 'window_time debe tener formato HH:MM:SS o HH:MM.')
                        return
                    }
                    if (/^\d{2}:\d{2}$/.test(timeValue)) {
                        parsedBody.window_time = timeValue + ':00'
                    }
                }

                ['entry_time', 'exit_time'].forEach(field => {
                    if (Object.prototype.hasOwnProperty.call(parsedBody, field) && parsedBody[field] !== null) {
                        const dt = new Date(parsedBody[field])
                        if (!Number.isNaN(dt.getTime())) {
                            parsedBody[field] = dt.toISOString()
                        }
                    }
                })

                const invalidDateTime = ['entry_time', 'exit_time'].find(field => {
                    if (!Object.prototype.hasOwnProperty.call(parsedBody, field) || parsedBody[field] === null) return false
                    return Number.isNaN(new Date(parsedBody[field]).getTime())
                })

                if (invalidDateTime) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', invalidDateTime + ' debe tener formato datetime ISO valido.')
                    return
                }

                this.loadingCavSave = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/shipments/scale/cav/' + this.selectedShippingWindowId + '/edit/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: parsedBody
                }

                axios(config)
                    .then(response => {
                        this.loadingCavSave = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', (response.data && response.data.message) || 'Datos del CAV actualizados correctamente.')
                        this.cavData = response.data && response.data.cav ? response.data.cav : response.data
                        this.initializeCavForm(this.cavData)
                    })
                    .catch(error => {
                        this.loadingCavSave = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', this.resolveCavEditError(error))
                    })
            },
            initializeCavForm (cav) {
                const nextForm = {}
                this.cavEditableKeys.forEach((key) => {
                    if (key === 'is_final') {
                        nextForm[key] = cav && typeof cav[key] === 'boolean' ? cav[key] : false
                        return
                    }
                    const value = cav ? cav[key] : ''
                    nextForm[key] = value === null || value === undefined ? '' : String(value)
                })

                this.cavForm = nextForm
                this.cavOriginal = { ...nextForm }
                this.cavDirtyFields = {}
                this.cavNullFields = {}
            },
            resetCavForm () {
                this.cavForm = {}
                this.cavOriginal = {}
                this.cavDirtyFields = {}
                this.cavNullFields = {}
            },
            markCavFieldEdited (fieldKey, value) {
                this.$set(this.cavDirtyFields, fieldKey, true)
                if (value !== null && value !== undefined) {
                    this.$set(this.cavNullFields, fieldKey, false)
                }
            },
            clearCavField (fieldKey) {
                this.$set(this.cavForm, fieldKey, '')
                this.$set(this.cavDirtyFields, fieldKey, true)
                this.$set(this.cavNullFields, fieldKey, true)
            },
            restoreCavField (fieldKey) {
                const original = Object.prototype.hasOwnProperty.call(this.cavOriginal, fieldKey)
                    ? this.cavOriginal[fieldKey]
                    : ''
                this.$set(this.cavForm, fieldKey, original)
                this.$set(this.cavDirtyFields, fieldKey, false)
                this.$set(this.cavNullFields, fieldKey, false)
            },
            buildCavPatchPayload () {
                const payload = {}
                this.cavEditableKeys.forEach((key) => {
                    if (!this.cavDirtyFields[key]) return
                    payload[key] = this.cavNullFields[key] ? null : this.normalizeCavFieldValue(key, this.cavForm[key])
                })
                return payload
            },
            normalizeCavFieldValue (fieldKey, value) {
                if (fieldKey === 'is_final') {
                    return Boolean(value)
                }
                if (value === null || value === undefined) return ''
                return String(value).trim()
            },
            isCavBooleanField (fieldKey) {
                return fieldKey === 'is_final'
            },
            isCavTextareaField (fieldKey) {
                return fieldKey === 'guard_notes_in' || fieldKey === 'guard_notes_out' || fieldKey === 'empresa_logo_b64'
            },
            getCavInputType (fieldKey) {
                if (fieldKey === 'window_date') return 'date'
                if (fieldKey === 'window_time') return 'time'
                if (fieldKey === 'weight_in_kg' || fieldKey === 'weight_out_kg' || fieldKey === 'weight_net_kg') return 'number'
                return 'text'
            },
            getCavFieldHint (fieldKey) {
                if (fieldKey === 'window_date') return 'Formato: YYYY-MM-DD'
                if (fieldKey === 'window_time') return 'Formato: HH:MM o HH:MM:SS'
                if (fieldKey === 'entry_time' || fieldKey === 'exit_time') return 'Formato: datetime ISO (ej. 2026-04-28T16:35:00Z)'
                return ''
            },
            getCavFieldLabel (fieldKey) {
                const labels = {
                    folio: 'Folio',
                    is_final: 'Documento final',
                    empresa_name: 'Empresa',
                    transport_company_name: 'Transportista',
                    client_name: 'Cliente',
                    destination_client_name: 'Cliente destino',
                    loading_area: 'Anden',
                    window_date: 'Fecha',
                    window_time: 'Hora',
                    entry_time: 'Hora entrada',
                    exit_time: 'Hora salida',
                    vehicle_plate: 'Placas',
                    vehicle_type: 'Tipo de vehiculo',
                    vehicle_economic_number: 'Numero economico',
                    driver_name: 'Conductor',
                    weight_in_kg: 'Peso entrada (kg)',
                    weight_out_kg: 'Peso salida (kg)',
                    weight_net_kg: 'Peso neto (kg)',
                    scale_number_in: 'No. bascula entrada',
                    scale_number_out: 'No. bascula salida',
                    guard_in_name: 'Guardia entrada',
                    guard_out_name: 'Guardia salida',
                    guard_notes_in: 'Notas guardia entrada',
                    guard_notes_out: 'Notas guardia salida',
                    supervisor_name: 'Supervisor',
                    double_verification_number: 'No. doble verificacion'
                }
                return labels[fieldKey] || fieldKey
            },
            resolveCavEditError (error) {
                if (!error || !error.response) return 'No fue posible actualizar el CAV.'

                const status = error.response.status
                const data = error.response.data || {}

                if (status === 401) return 'Sesion expirada o token invalido. Vuelve a iniciar sesion.'
                if (status === 403) return (data.error || data.detail || 'No tienes permisos para actualizar el CAV o el modulo CAV no esta activo.')
                if (status === 404) return (data.error || data.detail || 'No se encontro la ventana de embarque para actualizar CAV.')
                if (status === 400) return (data.error || data.detail || data.message || 'Solicitud invalida al actualizar CAV. Revisa formato de campos y folio unico.')

                return data.error || data.detail || data.message || 'No fue posible actualizar el CAV.'
            },
            downloadCavPdfByShippingWindowId (shippingWindowId) {
                if (!this.canViewCav) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Tu perfil no tiene permiso para descargar CAV.')
                    return
                }

                if (!shippingWindowId) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'No se encontro shipping_window_id para descargar CAV.')
                    return
                }

                this.selectedShippingWindowId = shippingWindowId
                this.loadingCavPdf = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/scale/cav/' + shippingWindowId + '/pdf/',
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    responseType: 'blob'
                }

                axios(config)
                    .then(response => {
                        this.loadingCavPdf = false
                        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', `CAV-${shippingWindowId}.pdf`)
                        document.body.appendChild(link)
                        link.click()
                        link.remove()
                        URL.revokeObjectURL(url)

                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', 'PDF CAV descargado correctamente.')
                    })
                    .catch(error => {
                        this.loadingCavPdf = false
                        let msg = 'No fue posible descargar el PDF CAV.'
                        if (error.response && error.response.status === 400 && error.response.data && error.response.data.has_weigh_in !== undefined) {
                            const missing = []
                            if (!error.response.data.has_weigh_in) missing.push('pesada de entrada')
                            if (!error.response.data.has_weigh_out) missing.push('pesada de salida')
                            msg = missing.length ? `No se puede generar el PDF. Faltan: ${missing.join(', ')}.` : msg
                        } else if (error.response && error.response.data && (error.response.data.error || error.response.data.detail)) {
                            msg = error.response.data.error || error.response.data.detail
                        }

                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', msg)
                    })
            },
            calculateDuration (accessTime, exitTime) {
                if (!accessTime || !exitTime) return '-'
                try {
                    const start = new Date(accessTime)
                    const end = new Date(exitTime)
                    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-'

                    const diffMs = end - start
                    if (diffMs < 0) return '-'

                    const hours = Math.floor(diffMs / (1000 * 60 * 60))
                    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

                    if (hours === 0) return `${minutes}m`
                    return `${hours}h ${minutes}m`
                } catch (e) {
                    return '-'
                }
            },
            cleanTransportFields () {
              this.typeService = null
              this.case_plates = null
              this.container_platform_plates = null
              this.transport_line = null
              this.supplier_customer_name = null
            },
            fillTransportFields (item) {
              this.typeService = item.download
              this.case_plates = item.case_plates
              this.container_platform_plates = item.container_platform_plates
              this.transport_line = item.transport_line
              this.supplier_customer_name = item.supplier_customer_name
            },
            exportPdfAccessUnion () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var adentro = this.$t('adentro')
                var pending_authorization = this.$t('pending_authorization')
                var completado = this.$t('completado')
                var waiting_room = this.$t('waiting_room')
                var no_firmado_completado = this.$t('no_firmado') + '/' + this.$t('completado')
                var denegado = this.$t('deny')
                var headerAccessNoCode = this.$t('headerAccess')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var con_codigo = this.$t('acceso_con_codigo')
                var sin_codigo = this.$t('acceso_sin_codigo')
                var total = 'Total: ' + this.access.length.toString()
                var columns = [{
                    access_qr_code: this.$t('type_of_access'),
                    guest_full_name: this.$t('Visitante'),
                    company_name: this.$t('Empresa'),
                    status: this.$t('estado'),
                    datetime_arrival: this.$t('hora_llegada'),
                    datetime_checkin: this.$t('hora_acceso'),
                    datetime_checkout: this.$t('hora_salida'),
                    host_full_name: this.$t('Anfitrion'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.setFontSize(8)
                        doc.setTextColor(150)
                        doc.text('Powered by Intrare', data.settings.margin.left, pageHeight - 10)

                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)
                        doc.setTextColor(40)
                        doc.text(str, pageSize.width - data.settings.margin.right - 40, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                          if (data.column.index === 0) {
                            if (data.cell.text.toString() === 'true') {
                              data.cell.text = con_codigo
                            } else {
                              data.cell.text = sin_codigo
                            }
                          }
                          if (data.column.index === 6) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 5) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 3) {
                            if (data.cell.text.toString() === '0') {
                              data.cell.text = pending_authorization
                            }
                            if (data.cell.text.toString() === '1') {
                              data.cell.text = adentro
                            }
                            if (data.cell.text.toString() === '2') {
                              data.cell.text = completado
                            }
                            if (data.cell.text.toString() === '3') {
                              data.cell.text = no_firmado_completado
                            }
                            if (data.cell.text.toString() === '4') {
                              data.cell.text = denegado
                            }
                            if (data.cell.text.toString() === '5') {
                              data.cell.text = waiting_room
                            }
                          }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            countDownTimerAccessNoCode(id) {
              if(this.countDownAuthorizedAccessNoCode > 0) {
                setTimeout(() => {
                  this.countDownAuthorizedAccessNoCode -= 1
                  this.countDownTimerAccessNoCode(id)
                }, 1000)
              } else {
                const config2 = {
                  method: 'get',
                  url: 'https://empresa-service.intrare.app/bitacora/' + id,
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                  },
                };
                axios(config2)
                    .then(ok => {
                      this.dataAccessNoCode = ok.data[0]
                      console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                      console.log(this.dataAccessNoCode)
                      console.log('Id = ', this.dataAccessNoCode.id)
                    })
                    .catch(error => {
                      console.log(error)
                    })
              }
            },
            countDownSignTimer() {
                if(this.countDownSign > 0) {
                    setTimeout(() => {
                        this.countDownSign -= 1
                        this.countDownSignTimer()
                    }, 1000)
                }
            },
            getRecordAccessNoCodeById(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            getRecordAccessNoCodeByIdLoading(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                    this.data_accesos_without_code = this.dataAccessNoCode
                    this.dialog_accesos_without_code = true
                    console.log(this.data_accesos_without_code)
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            notificar_anfitrion_acceso_sin_codigo(id){
              this.loading = true
              console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', id)
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + id + '/',
                headers: {
                  'Content-Type': 'application/json',
                }
              };
              axios(config)
                  .then(response => {
                    this.loading = false
                    this.countDownAuthorizedAccessNoCode = 30
                    this.countDownTimerAccessNoCode(id)
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'success')
                    this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                    setTimeout(this.clear3, 3000)
                  })
                  .catch(error => {
                    this.loading = false
                    console.log(error)
                  })
            },
            countDownTimer() {
                if(this.countDownAuthorized > 0) {
                    setTimeout(() => {
                        this.countDownAuthorized -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            countDownPassTimer() {
                if(this.countDownPass > 0) {
                    setTimeout(() => {
                        this.countDownPass -= 1
                        this.countDownPassTimer()
                    }, 1000)
                }
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', this.idAccessNoCode)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + this.idAccessNoCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownAuthorized = 30
                        this.countDownTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(id){
                this.loading = true
                console.log('Avisar al Anfitrión que firme el pase de salida del acceso sin codigo = ', id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPassAccessNoCode/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownSign = 30
                        this.countDownSignTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                          method: 'get',
                          url: 'https://empresa-service.intrare.app/bitacora/' + id,
                          headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                          },
                        };
                        axios(config2)
                            .then(ok => {
                              this.dataAccessNoCode = ok.data[0]
                              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                              console.log(this.dataAccessNoCode)
                              console.log('Id = ', this.dataAccessNoCode.id)
                            })
                            .catch(error => {
                              console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            create_check_out_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/registrar_salida/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.head_color = 'green display-1 text--primary'
                        this.dialog_errores = true
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            create_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                      id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                        this.getRecordAccessNoCodeById(id)
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            xOffset: function(pdf, text){
                console.log('Page width =', pdf.internal.pageSize.width)
                console.log('text width =', pdf.getStringUnitWidth(text))
                console.log('Font width =', pdf.internal.getFontSize())
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            download_gafete (fullname_guest, fullname_host, date, company_logo){
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2.3,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2.3, 0.42, 3.7, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(date,
                    2.7,
                    0.6)
                pdf.setFontSize(14)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_guest,
                    this.xOffset(pdf, fullname_guest),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
                pdf.setFontSize(14)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_host,
                    this.xOffset(pdf, fullname_host),
                    1.70)
                pdf.setTextColor('#000000')
                toDataUrl(company_logo, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7)
                    pdf.save('gafete.pdf')
                })
                // pdf.save('gafete.pdf')
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            estadoFormat(value){
                if (value === 0)
                    return  this.$t('pending_authorization')
                if (value === 1)
                    return  this.$t('adentro')
                if (value === 2)
                    return  this.$t('completado')
                if (value === 3)
                    return  this.$t('no_firmado') + '/' + this.$t('completado')
                if (value === 4)
                    return  this.$t('deny')
                if (value === 5)
                    return  this.$t('waiting_room')
            },
            typeAccessFormat(value) {
              if (value === true)
                return  this.$t('acceso_con_codigo')
              return  this.$t('acceso_sin_codigo')
            },
            get_current_date_menu: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date_menu2: function (){
                var today = new Date();
                today.setDate(today.getDate() + 7)
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }

                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            split_date: function(date, date2){
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            get_access_without_code_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacoraByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_without_code = []
                        else
                            this.accesos_without_code = response.data
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            get_access_no_code_express_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_no_code_express = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacora_expressByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_no_code_express = []
                        else
                            this.accesos_no_code_express = response.data
                        this.loading_data_accesos_no_code_express = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_no_code_express = false
                        console.log(error)
                    })

            },
            get_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status === 204)
                            this.accesos = []
                        else
                            this.accesos = response.data
                        this.loading_data_accesos = false
                    })
                    .catch(error => {
                        this.loading_data_accesos = false
                        console.log(error)
                    })

            },
            fill_fields: function(item){
                this.getRecordAccessNoCodeByIdLoading(item.id)
            },
            fill_fields_express: function(item){
                this.data_accesos_no_code_express = item
                console.log(this.data_accesos_no_code_express)
            },
            firmar: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            firmar_express: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida_express/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            exportPdfAccess () {
                var adentro = this.$t('adentro')
                var completado = this.$t('completado')
                var denegado = this.$t('deny')
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessExcel = this.$t('headerAccessExcel')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos.length.toString()
                var columns = [{
                    guestFName: this.$t('Visitante'),
                    guestLName: this.$t('Apellido'),
                    companyName: this.$t('Empresa'),
                    temperature: this.$t('temperature'),
                    estado: this.$t('estado'),
                    fecha_hora_acceso: this.$t('hora_acceso'),
                    fecha_hora_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                    hostLastName: this.$t('Apellido'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.accesos,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessExcel, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                            if (data.column.index === 4) {
                                if (data.cell.text.toString() === '1') {
                                    data.cell.text = adentro
                                } else
                                if (data.cell.text.toString() === '2') {
                                    data.cell.text = denegado
                                } else {
                                    data.cell.text = completado
                                }
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.addPage()
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessNoCode = this.$t('accesos_sin_codigo')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_without_code.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    empresa: this.$t('Empresa'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_without_code,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.setFontSize(8)
                        doc.setTextColor(150)
                        doc.text('Powered by Intrare', data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 3) {
                            if(data.cell.text.toString() === ''){
                                data.cell.text = pendiente
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfExpressAccess () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'

                var headerAccessNoCode = this.$t('historial_accesos_sin_codigo')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_no_code_express.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    areaName: this.$t('Area'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    notas: this.$t('Notas'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_no_code_express,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.setFontSize(8)
                        doc.setTextColor(150)
                        doc.text('Powered by Intrare', data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('accessNocode' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportExcelAccessUnion () {
                const fechaInicial = this.formatDate(this.date)
                const fechaFinal = this.formatDate(this.date2)
                const sheetName = 'Accesos'

                const headers = [
                    this.$t('type_of_access'),
                    this.$t('Visitante'),
                    this.$t('Empresa'),
                    this.$t('estado'),
                    this.$t('hora_llegada'),
                    this.$t('hora_acceso'),
                    this.$t('hora_salida'),
                    this.$t('Anfitrion'),
                ]

                const data = this.access.map(item => [
                    item.access_qr_code === true ? this.$t('acceso_con_codigo') : this.$t('acceso_sin_codigo'),
                    item.guest_full_name,
                    item.company_name,
                    this.estadoFormat(item.status),
                    item.datetime_arrival,
                    item.datetime_checkin,
                    item.datetime_checkout,
                    item.host_full_name,
                ])

                const ws = XLSX.utils.aoa_to_sheet([[
                    this.$t('period') + ': ' + fechaInicial + ' ' + this.$t('al') + ' ' + fechaFinal
                ]])
                XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A3' })
                XLSX.utils.sheet_add_aoa(ws, data, { origin: 'A4' })

                // Add footer
                const footerRow = data.length + 5
                XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '', '', 'Powered by Intrare']], { origin: `A${footerRow}` })

                ws['!cols'] = [
                    { wch: 15 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 15 },
                    { wch: 18 },
                    { wch: 18 },
                    { wch: 18 },
                    { wch: 20 }
                ]

                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, sheetName)
                XLSX.writeFile(wb, 'accesos_' + this.date + '_' + this.date2 + '.xlsx')
            },
            exportExcelAccess () {
                const fechaInicial = this.formatDate(this.date)
                const fechaFinal = this.formatDate(this.date2)
                const sheetName = 'Accesos Sin Código'

                const headers = [
                    this.$t('Visitante'),
                    this.$t('Empresa'),
                    this.$t('hora_acceso'),
                    this.$t('hora_salida'),
                    this.$t('Anfitrion'),
                ]

                const data = this.accesos_without_code.map(item => [
                    item.nombre,
                    item.empresa,
                    item.f_acceso,
                    item.f_salida,
                    item.hostFirstName,
                ])

                const ws = XLSX.utils.aoa_to_sheet([[
                    this.$t('period') + ': ' + fechaInicial + ' ' + this.$t('al') + ' ' + fechaFinal
                ]])
                XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A3' })
                XLSX.utils.sheet_add_aoa(ws, data, { origin: 'A4' })

                // Add footer
                const footerRow = data.length + 5
                XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', 'Powered by Intrare']], { origin: `A${footerRow}` })

                ws['!cols'] = [
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 18 },
                    { wch: 18 },
                    { wch: 20 }
                ]

                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, sheetName)
                XLSX.writeFile(wb, 'accesos_sin_codigo_' + this.date + '_' + this.date2 + '.xlsx')
            },
            exportPdfParking () {
                const fechaInicial = this.formatDate(this.date)
                const fechaFinal = this.formatDate(this.date2)
                const doc = new jsPDF("landscape", "pt", "letter")
                const headerTitle = this.$t('access_history_shipments')
                const period = this.$t('period')
                const al = this.$t('al')
                const pendiente = this.$t('pendiente')
                const total = 'Total: ' + this.dataAccessParking.length.toString()

                const isEmpresa86 = this.id_empresa === '86' || this.id_empresa === 86

                let columns, data

                if (isEmpresa86) {
                    columns = [{
                        window_date: 'Fecha Invitación',
                        client_name: 'Destino',
                        window_time: 'Hora Invitación',
                        access_time_formatted: 'Llegada',
                        loading_start_time_formatted: 'Entrada a Carga',
                        loading_end_time_formatted: 'Salida de Carga',
                        exit_time_formatted: this.$t('hora_salida'),
                        carrier_company_name: 'Línea Transportista',
                        duration: 'Duración',
                        registered_by_name: this.$t('Vigilante'),
                    }]

                    data = this.dataAccessParking.map(item => [
                        item.window_date || pendiente,
                        item.client_name || pendiente,
                        item.window_time || pendiente,
                        item.access_time_formatted || pendiente,
                        item.loading_start_time_formatted || pendiente,
                        item.loading_end_time_formatted || pendiente,
                        item.exit_time_formatted || pendiente,
                        item.carrier_company_name || pendiente,
                        this.calculateDuration(item.access_time, item.exit_time),
                        item.registered_by_name
                    ])
                } else {
                    columns = [{
                        window_date: 'Fecha Invitación',
                        client_name: 'Destino',
                        window_time: 'Hora Invitación',
                        access_time_formatted: 'Llegada',
                        loading_start_time_formatted: 'Entrada a Carga',
                        loading_end_time_formatted: 'Salida de Carga',
                        exit_time_formatted: this.$t('hora_salida'),
                        registered_by_name: this.$t('Vigilante'),
                    }]

                    data = this.dataAccessParking.map(item => [
                        item.window_date || pendiente,
                        item.client_name || pendiente,
                        item.window_time || pendiente,
                        item.access_time_formatted || pendiente,
                        item.loading_start_time_formatted || pendiente,
                        item.loading_end_time_formatted || pendiente,
                        item.exit_time_formatted || pendiente,
                        item.registered_by_name
                    ])
                }

                doc.autoTable({
                    head: columns,
                    body: data,
                    didDrawPage: (pageData) => {
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.text(headerTitle, pageData.settings.margin.left + 20, 38)
                        doc.setFontSize(12)
                        doc.text(period + ' ' + fechaInicial + ' ' + al + ' ' + fechaFinal, pageData.settings.margin.left + 20, 60)
                        doc.text(total, pageData.settings.margin.left + 20, 78)

                        // Footer
                        const pageSize = doc.internal.pageSize
                        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.setFontSize(8)
                        doc.setTextColor(150)
                        doc.text('Powered by Intrare', pageData.settings.margin.left, pageHeight - 10)
                    },
                    margin: { top: 90 }
                })

                doc.save('embarques_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportExcelParking () {
                const fechaInicial = this.formatDate(this.date)
                const fechaFinal = this.formatDate(this.date2)
                const sheetName = 'Embarques'
                const isEmpresa86 = this.id_empresa === '86' || this.id_empresa === 86
                const pendiente = this.$t('pendiente')

                let headers, data

                if (isEmpresa86) {
                    headers = [
                        'Fecha Invitación',
                        'Destino',
                        'Hora Invitación',
                        'Llegada',
                        'Entrada a Carga',
                        'Salida de Carga',
                        this.$t('hora_salida'),
                        'Línea Transportista',
                        'Duración',
                        this.$t('Vigilante'),
                    ]

                    data = this.dataAccessParking.map(item => [
                        item.window_date || pendiente,
                        item.client_name || pendiente,
                        item.window_time || pendiente,
                        item.access_time_formatted || pendiente,
                        item.loading_start_time_formatted || pendiente,
                        item.loading_end_time_formatted || pendiente,
                        item.exit_time_formatted || pendiente,
                        item.carrier_company_name || pendiente,
                        this.calculateDuration(item.access_time, item.exit_time),
                        item.registered_by_name
                    ])
                } else {
                    headers = [
                        'Fecha Invitación',
                        'Destino',
                        'Hora Invitación',
                        'Llegada',
                        'Entrada a Carga',
                        'Salida de Carga',
                        this.$t('hora_salida'),
                        this.$t('Vigilante'),
                    ]

                    data = this.dataAccessParking.map(item => [
                        item.window_date || pendiente,
                        item.client_name || pendiente,
                        item.window_time || pendiente,
                        item.access_time_formatted || pendiente,
                        item.loading_start_time_formatted || pendiente,
                        item.loading_end_time_formatted || pendiente,
                        item.exit_time_formatted || pendiente,
                        item.registered_by_name
                    ])
                }

                const ws = XLSX.utils.aoa_to_sheet([[
                    this.$t('period') + ': ' + fechaInicial + ' ' + this.$t('al') + ' ' + fechaFinal
                ]])
                XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A3' })
                XLSX.utils.sheet_add_aoa(ws, data, { origin: 'A4' })

                // Add footer
                const footerRow = data.length + 5
                if (isEmpresa86) {
                    const footerColumns = ['', '', '', '', '', '', '', '', '', 'Powered by Intrare']
                    XLSX.utils.sheet_add_aoa(ws, [footerColumns], { origin: `A${footerRow}` })
                    ws['!cols'] = [
                        { wch: 15 },
                        { wch: 18 },
                        { wch: 15 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 12 },
                        { wch: 15 }
                    ]
                } else {
                    XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '', '', 'Powered by Intrare']], { origin: `A${footerRow}` })
                    ws['!cols'] = [
                        { wch: 15 },
                        { wch: 18 },
                        { wch: 15 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 18 },
                        { wch: 15 }
                    ]
                }

                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, sheetName)
                XLSX.writeFile(wb, 'embarques_' + this.date + '_' + this.date2 + '.xlsx')
            },
            submit: function(){
                this.split_date(this.date, this.date2)
                this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            },
            get_access_union_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_access2 = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRangeUnion/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                          this.access = response.data
                        this.loading_data_access2 = false
                    })
                    .catch(error => {
                        this.loading_data_access2 = false
                        console.log(error)
                    })

            },
            addAccessCarrierData () {
              this.loading = true
              let URL_ACCESS = 'https://empresa-service.intrare.app/empresas/access/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_NO_CODE = 'https://empresa-service.intrare.app/bitacora/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_CONTRACTOR = 'https://empresa-service.intrare.app/access_contractor/update/transport_data/' + this.idAccess + '/'
              let URL_FINAL = ''
              if(this.accessQRCode === false) {
                URL_FINAL = URL_ACCESS_NO_CODE
              } else {
                if (this.accessContractor === true) {
                    URL_FINAL = URL_ACCESS_CONTRACTOR
                } else {
                    URL_FINAL = URL_ACCESS
                }
              }
              // console.log('Tipo de Servicio = ', this.typeService)
              if (this.typeService !== null && this.case_plates === null && this.container_platform_plates === null && this.transport_line === null && this.supplier_customer_name === null)
              {
                  this.bandConfirm = true
                  this.loading = false
              } else
                if (this.typeService === null) {
                  this.loading = false
                } else {
                  const config = {
                    method: 'patch',
                    url: URL_FINAL,
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept-Language': this.language,
                      'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      download: this.typeService,
                      case_plates: this.case_plates,
                      container_platform_plates: this.container_platform_plates,
                      transport_line: this.transport_line,
                      supplier_customer_name: this.supplier_customer_name
                    }
                  };
                  axios(config)
                      .then(response => {
                        this.loading = false
                        this.dialogTransport = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('data_added_successfully'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                      })
                      .catch(error => {
                        this.loading = false
                        console.log(error)
                      })
                }
            },
            altaPlacas () {
                this.loading = true
                this.errores = []
                var bodyFormData = new FormData()
                var fileImage = null
                const newID = this.$uuid.v4()

                if (this.img !== '' && this.img.length > 6) {
                    fileImage = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
                }
                bodyFormData.append('placas', fileImage)
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/placas/' + this.idAccess + '/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('placas_alta'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
                    .finally(() => (this.loading = false, this.dialogPlacas =false))

            },
            clear () {
                this.alerta = false
                this.errores = []
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
                this.img = ''
            },
            open17PointsModal (item) {
                const shippingWindowId = this.resolveShippingWindowId(item)
                if (!shippingWindowId) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Este registro no incluye shipping_window_id para consultar revisión de seguridad.')
                    return
                }

                if (!this.canViewSecurityRevision) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'Tu perfil no tiene permiso para consultar revisión de seguridad.')
                    return
                }

                this.selected17PointsShippingWindowId = shippingWindowId
                this.dialog17Points = true
                this.fetch17PointsData(shippingWindowId)
            },
            close17PointsModal () {
                this.dialog17Points = false
                this.selected17PointsShippingWindowId = null
                this.data17Points = null
            },
            refresh17PointsData () {
                if (this.selected17PointsShippingWindowId) {
                    this.fetch17PointsData(this.selected17PointsShippingWindowId)
                }
            },
            fetch17PointsData (shippingWindowId) {
                this.loading17Points = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/api/security/revisions-by-shipping/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        shipping_window_id: shippingWindowId
                    }
                }

                axios(config)
                    .then(response => {
                        this.data17Points = response.data
                        this.loading17Points = false
                    })
                    .catch(error => {
                        this.loading17Points = false
                        this.data17Points = null
                        const errorMsg = (error.response && error.response.data && (error.response.data.error || error.response.data.detail)) || 'No se pudo consultar la revisión de seguridad.'
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', errorMsg)
                    })
            },
            getStatusColor (cumple) {
                if (cumple === 'si') return 'success'
                if (cumple === 'no') return 'error'
                if (cumple === 'na') return 'warning'
                return 'grey'
            },
        }
    }
</script>


<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }

    .inspection-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    .inspection-table thead {
        background-color: #1976d2;
        color: white;
    }

    .table-header {
        background-color: #1976d2;
        color: white;
    }

    .table-header-cell {
        padding: 12px;
        text-align: left;
        font-weight: bold;
        border: 1px solid #1976d2;
    }

    .table-cell {
        padding: 10px 12px;
        border: 1px solid #e0e0e0;
    }

    .inspection-table tbody tr {
        transition: background-color 0.2s ease;
    }

    .inspection-table tbody tr:hover {
        background-color: #f5f5f5;
    }

    .inspection-table tbody tr.row-error {
        background-color: #ffebee;
    }

    .inspection-table tbody tr.row-error .table-cell {
        border-color: #ef5350;
    }

    .inspection-table tbody tr.row-warning {
        background-color: #fff3e0;
    }

    .inspection-table tbody tr.row-warning .table-cell {
        border-color: #ffa726;
    }
</style>
